<template>
  <div class="container-fluid">
    <help-card :topic="'dhr'"></help-card>
    <div class="row  justify-content-md-center">
      <div class="col-10">
        <notification-alert :authenticated="isAuthenticated && (hasRole('administrator') || hasRole('support'))" :userId="getProfile('id')"></notification-alert>
        <h2>{{title}}</h2>
      </div>
    </div>
    <b-modal id="releaseDevice" ok-title="Yes" ok-variant="danger" cancel-title="No" @ok="releaseDevice(idToRelease)" title="Are you sure?">
      <div class="mb-3">
        This device has not passed the END test!
        Are you absolutely sure you want to continue?
      </div>
    </b-modal>
    <div>
      <div class="row justify-content-md-center mb-3">
        <div class="col-1"><label for="filter">Filter</label></div>
        <div class="col-4">
          <b-form-input v-model="filter"
                  type="text"
                  id="filter"
                  placeholder="e.g. CFR, DMU"></b-form-input>
        </div>
        <div class="col-5"></div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-10">
          <b-table class="mb-5" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :striped="false"
                    :hover="true"
                    :busy.sync="isBusy"
                    :items="fetchReports"
                    :fields="reportFields"
                    :outlined="true"
                    :small="true"
                    :filter="filter"
                    :current-page="currentPage"
                    :per-page="perPage"
                    ref="device-table">
            <template v-slot:cell(selected)="data" label="selected">
                <b-form-checkbox plain @click.native.stop @change="clickedCheckbox" v-model="data.item.selected">
                  </b-form-checkbox>
              </template>
            <template v-slot:cell(index)="data" label="test">
              {{data.index}}
            </template>
            <template v-slot:cell(production_date)="data" label="test">
              {{data.item.production_date | formatDate}}
            </template>
            <template v-slot:cell(batch_id)="data" label="result">
              {{data.item.batch_id || "Not assigned"}}
            </template>
            <template v-slot:cell(released_by)="data" label="result">
              {{data.item.username}}
            </template>
            <template v-slot:cell(status)="data" label="result">
              {{data.item.result}}
            </template>
            <template v-slot:cell(download_certificate)="data" label="certificate">
              <a :href="'report/'+data.item.id+'/certificate'">Certificate</a>
            </template>
            <template v-slot:cell(report)="data" label="report">
              <a v-if="data.item.released_by" href="#" @click.prevent.stop="downloadReport(data.item.id, 'report', data.item.end_serial)"><octicon name="desktop-download"></octicon></a>
            </template>
            <template v-slot:cell(certificate)="data" label="report">
              <a  v-if="data.item.result == 'Pass' && data.item.released_by && data.item.revision === 'CFR00101a'" href="#" @click.prevent.stop="downloadReport(data.item.id, 'certificate', data.item.end_serial)"><octicon name="desktop-download"></octicon></a>
            </template>
            <template v-slot:cell(documents)="data" label="report">
              <span>
                <a href="#" @click.prevent.stop v-b-modal="'uploadBox'+data.item.id">Add</a>
                  <!-- Modal Component -->
                <b-modal @ok="uploadDocument(data.item.id)" :id="'uploadBox'+data.item.id" title="Select document to upload">
                    <div class="mb-3">
                      Choose the documents you want to add to {{data.item.end_serial}}
                    </div>
                    <b-form-file multiple v-model="fileList" ref="fileinput" placeholder="Choose a file..."></b-form-file>
                    <div class="mt-3">Selected file(s): {{fileList && cutString(fileList.map(f=>f.name).join(', '))}}</div>
                </b-modal>
              </span>
            </template>
            <template v-slot:cell(approval)="data" label="released">
              <template>
                <a v-b-modal.releaseDevice v-if="!data.item.released_by && data.item.result != 'Pass'" href="#" @click.prevent.stop="idToRelease = data.item.id">Release</a>
                <a v-else-if="!data.item.released_by" href="#" @click.prevent.stop="releaseDevice(data.item.id)">Release</a>
              </template>
              <template v-if="data.item.released_by"><octicon name="verified"></octicon></template>
            </template>
            <template v-slot:cell(show_details)="row">
              <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
              <a href="#" @click.prevent.stop="toggleRow(row)">
                {{row.detailsShowing ? 'Hide' : 'Show'}}
                <octicon :name="row.detailsShowing ? 'chevron-up' : 'chevron-down'"></octicon>
              </a>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card class="custom-shadow-grey rounded-0" border-variant="dark" bg-variant="white">
                <strong slot="header">{{row.item.end_serial}}</strong>
                <template v-if="row.item.__meta__.documents_count > 0" >
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-left"><b>Documents</b></b-col>
                  </b-row>
                  <document-list-table :device_id="row.item.id"></document-list-table>
                </template>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-left"><b>Reports</b></b-col>
                </b-row>
                <report-list-table :device_id="row.item.id" :released="!!row.item.released_by"></report-list-table>
              </b-card>
            </template>
          </b-table>
        </div>
      </div>
      <div v-if="(hasRole('administrator') || hasRole('support') || hasRole('productionOwner'))" class="row justify-content-md-center">
        <div class="col-2">With selected devices do:</div>
        <div class="col-4">
          <b-input-group id="batch_id" prepend="Assign to batch:" v-if="hasRole('administrator') || hasRole('support')">
            <b-form-input type="text" placeholder="e.g. DMU20180912" v-model="batch_id"></b-form-input>
            <b-input-group-append>
              <b-button v-if="hasRole('administrator') || hasRole('support')"
                :disabled="!items_selected"
                @click.prevent.stop="assignBatchId">Assign</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-4">
          <b-button-group>
            <b-button v-if="hasRole('administrator') || hasRole('productionOwner')" :disabled="!items_selected" @click.prevent.stop="releaseDevice(selected_items)"><octicon name="checklist"></octicon> Release devices</b-button>
            <b-button @click.prevent.stop v-b-modal="'uploadMultiple'"><octicon name="repo-force-push"></octicon> Upload reports</b-button>
          </b-button-group>
        </div>
        <b-modal @ok="uploadDocument('multiple')" id="uploadMultiple" title="Select documents to upload">
          <div class="mb-3">
            Choose the documents you want to upload
          </div>
          <b-form-file multiple v-model="fileList" ref="fileinput" placeholder="Choose a file..."></b-form-file>
          <div class="mt-3">Selected file(s): {{fileList && cutString(fileList.map(f=>f.name).join(', '))}}</div>
        </b-modal>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-6 mt-3">
          <b-pagination size="md" align="center" :total-rows="totalRows" v-model="currentPage" :per-page="perPage"></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import Octicon from 'vue-octicon/components/Octicon.vue'
import { mapGetters } from 'vuex'
import reportListTable from './ReportListTable'
import documentListTable from './DocumentListTable'
import HelpCard from './../components/HelpCard'
import NotificationAlert from './../components/NotificationAlerts'

Vue.filter('formatDate', function(value) {
  // console.log(value)
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD HH:mm')
  }
})
export default {
  name: 'report-list',
  components: {
    Octicon,
    reportListTable,
    documentListTable,
    HelpCard,
    NotificationAlert
  },
  data () {
    return {
      props: ['device_serial'],
      sortBy: 'id',
      sortDesc: true,
      isBusy: false,
      graphLoaded: false,
      devices: [],
      openRow: null,
      batch_id: null,
      fileList: [],
      currentPage: 1,
      idToRelease: null,
      perPage: 15,
      filter: this.$route.params.device_serial ? this.$route.params.device_serial : "",
      title: this.$route.params.device_serial ? `Records for: ${this.$route.params.device_serial}` : 'Device History Records',
      totalRows: 0,
      reportFields:
      [
        { key: 'selected', label: '' },
        { key: 'end_serial', sortable: true },
        { key: 'last_operation', label: 'Latest operation', sortable: true },
        { key: 'production_date', label: 'Date', sortable: true },
        { key: 'revision', sortable: true },
        { key: 'batch_name', label: 'Batch', sortable: true },
        { key: 'status', sortable: true },
        { key: 'company', label: 'Produced by', sortable: true },
        { key: 'released_by', sortable: true },
        'documents',
        { key: 'approval', label: 'Released' },
        { key: 'show_details', label: 'Details' }
      ]
    }
  },
  computed: {
    items_selected: function () {
      return this.devices.some(r => r.selected)
    },
    selected_items: function () {
      return this.devices.filter(r => r.selected).map(r => r.id)
    },
    ...mapGetters(['isAuthenticated', 'authStatus', 'hasRole', 'hasSignature', 'getProfile'])
  },
  methods: {
    toggleRow(row) {
      console.log(row)
      if ((this.openRow) && (this.openRow.detailsShowing) && (this.openRow.index !== row.index)) {
        this.openRow.toggleDetails()
        this.openRow.detailsShowing = false
      }
      row.toggleDetails()
      row.detailsShowing = !row.detailsShowing
      this.openRow = row.detailsShowing ? row : null
    },
    cutString(text) {
      let wordsToCut = 2
      var wordsArray = text.split(" ")
      if (wordsArray.length > wordsToCut) {
        var strShort = ""
        for (let i = 0; i < wordsToCut; i++) {
          strShort += wordsArray[i] + " "
        }
        return strShort + "..."
      } else {
        return text
      }
    },
    roundToFour(num) {
      let roundNum = +(Math.round(num + "e+4") + "e-4")
      return isNaN(roundNum) ? num : roundNum
    },
    clickedRow(item, index, event) {
      window.location = "/report/" + item.id
    },
    clickedCheckbox(item, index, event) {
      console.log("Checkbox!", item, index)
      // console.log("data!", this.$refs)
      // window.location = "/report/"+item.id
    },
    getFinalTestResult(tests) {
      // Check if there is a fail in one of the tests WARNING do not test for Pass since there can be retries
      return tests.every(test => { return test.result.toUpperCase() != "FAIL" }) ? "PASS" : "FAIL"
    },
    fetchReports(ctx) {
      console.log("Current_page", ctx)
      this.isBusy = true
      return this.$http.get(`/device`, { params: ctx }).then(response => {
        console.log(response)
        this.devices = response.data.data
        this.devices.forEach((device) => {
          // Mark released devices
          if (device.released_by !== null) {
            device._rowVariant = 'success'
          }

          // Mark Failed devices
          if (device.result == 'Fail') {
            device._rowVariant = 'custom-red'
          }
          // MIGHT BE NEEDED IN THE FUTURE: Format DMU devices. Remove prefix
          // device.end_serial = device.end_serial.replace(/DMU/g, '')
        })
        this.totalRows = parseInt(response.data.total)
        this.isBusy = false
        return (this.devices)
      }).catch(error => {
        console.log(error)
        // Here we could override the busy state, setting isBusy to false
        this.isBusy = false
        // Returning an empty array, allows table to correctly handle busy state in case of error
        return []
      })
    },
    downloadReport(id, type, name) {
      this.$http.get(`/device/${type}/${id}.pdf`, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${name}_${type}.pdf`) // or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },
    uploadDocument(id) {
      // this.isBusy = true
      const formData = new FormData()
      let sizeError = false

      if (!this.fileList.length) return
      // append the files to FormData
      this.fileList.forEach(x => {
        console.log("Adding document", x)
        formData.append('documents[]', x, x.name)
        // 5mb file size limit
        if (x.size > 5000000) {
          sizeError = true
        }
      })

      if (sizeError) {
        console.log('File size limitation exceeded. Upload canceled!')
        return
      }
      console.log("FormData", formData)

      this.$http.post(`/device/${id}/upload`, formData).then((response) => {
        this.$refs.fileinput.reset()
        this.$refs['device-table'].refresh()
      })
    },
    releaseDevice(id) {
      let ids = Array.isArray(id) ? id : [id]
      // this.isBusy = true
      this.$http.put(`device/release`, {
        devices: ids
      }).then(response => {
        this.$refs['device-table'].refresh()
      })
    },
    assignBatchId() {
      this.$http.put(`/device/`, {
        devices: this.devices.filter(r => r.selected).map(r => r.id),
        batch_id: this.batch_id
      }).then(response => {
        console.log(response, this.$refs)
        this.$refs['device-table'].refresh()
        // this.$root.$emit('bv::refresh::table', 'device-table')
        // this.fetchReports()
      })
    }
  },
  created() {
    if (this.hasRole('administrator') || this.hasRole('productionOwner')) {
      // Add columns based on roles
      this.reportFields.push('approval')
    }
    this.reportFields.push({ key: 'show_details', label: "" })
  }
}
</script>
